import { useEffect, useState } from 'react'
import { SelectCustom } from '../../../../ui/molecules/select'
import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { format } from "date-fns";
import TextArea from '../../../../ui/molecules/textArea'
import { ProtocolSearch } from '../../../../ui/molecules/ProtocolSearch'
import { TableSelect } from '../../../../ui/molecules/tableSelect';
import { TableSelectWithOperations } from '../../../../ui/molecules/tableSelectWithOperations';
import { GetAllConversionPeriods } from '../../periodoConversione/slice';
import { GetAllReportings } from '../../segnalazioni/slice';


export function AddNewM018FormsStep2() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const [protocolType, setProtocolType] = useState<string>('')
    const conversionPeriodState = useAppSelector(state => state.conversionPeriod)
    const [pcOptions, setPcOptions] = useState<{ value: string; label: string }[]>([]);
    const [reporting, setReporting] = useState<{ value: string; label: string }[]>([]);
    const reportingState = useAppSelector(state => state.reporting)

    const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setProtocolType(event.target.value)
    }

    useEffect(() => {
        if (sessionState.selected.customerId)
            dispatch(GetAllConversionPeriods({
                page: 0,
                itemsPerPage: 100,
                customerId: sessionState.selected.customerId
            }))
    }, [])

    useEffect(() => {
        dispatch(GetAllConversionPeriods({ itemsPerPage: 0, page: 0 }))
    }, [])

    useEffect(() => {
        if (conversionPeriodState.getAllConversionPeriodsStatus === 'successfully') {
            const conversionPeriod = conversionPeriodState.getAllConversionPeriodsResponse?.data || [];

            const options = conversionPeriod.map((singleCp) => ({
                value: singleCp.id,
                label: (singleCp.requestProtocolInfo ? singleCp.requestProtocolInfo : '') + " - " + new Date(singleCp.requestProtocolDate).toLocaleDateString('it-IT')
            }));

            setPcOptions(options);
        }
    }, [conversionPeriodState.getAllConversionPeriodsStatus]);

    useEffect(() => {
        dispatch(GetAllReportings({ itemsPerPage: 0, page: 0, customerId: sessionState.selected.customerId! }))
    }, [])

    useEffect(() => {
        if (reportingState.getAllReportingStatesStatus === 'successfully') {
            const conversionPeriod = reportingState.getAllReportingStatesResponse?.data || [];

            const options = conversionPeriod.map((singleRp) => ({
                value: singleRp.id,
                label: (singleRp.departureProtocolInfo ? singleRp.departureProtocolInfo : '') + " - " + new Date(singleRp.date).toLocaleDateString('it-IT')
            }));

            setReporting(options);
        }
    }, [reportingState.getAllReportingStatesStatus]);


    return (
        <div>
            <div className="formFieldset-container">
                <div className='formFieldset-header'>
                    <div className='text-left'>
                        <span className='rid-title' style={{ color: '#fff' }}>Gestione Non Conformità</span>
                    </div>
                </div>
                <div style={{ padding: '24px 24px 32px 24px' }}>
                </div>
            </div>
            <div className="formFieldset-container">
                <div className='formFieldset-header'>
                    <div className='text-left'>
                        <span className='rid-title' style={{ color: '#fff' }}>Segnalazioni Operatore</span>
                    </div>
                </div>
                <div style={{ padding: '24px 24px 32px 24px' }}>
                    <div className='pb-5 borderBottomLightGreen' style={{ display: 'flex', flex: 'wrap', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.3' }}>
                            <SelectCustom
                                label="Segnalazioni Operatore"
                                placeholder={'Segnalazione Operatore'}
                                options={reporting}
                                onChange={(value) => { console.log(value) }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="formFieldset-container">
                <div className='formFieldset-header'>
                    <div className='text-left'>
                        <span className='rid-title' style={{ color: '#fff' }}>Riduzione Periodo Conversione</span>
                    </div>
                </div>
                <div style={{ padding: '24px 24px 32px 24px' }}>
                    <div className='pb-5 borderBottomLightGreen' style={{ display: 'flex', flex: 'wrap', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.3' }}>
                            <SelectCustom
                                label="Riduzione Periodo Conversione"
                                placeholder={'Periodo Conversione'}
                                options={pcOptions}
                                onChange={(value) => { console.log(value) }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="formFieldset-container">
                <div className='formFieldset-header'>
                    <div className='text-left'>
                        <span className='rid-title' style={{ color: '#fff' }}>Richieste Varie</span>
                    </div>
                </div>
                <div className='mt-4' style={{ padding: '0px 24px' }}>
                    <div style={{ display: 'flex', gap: '16px' }}>
                        <div style={{ flex: '0 0 33.33%' }}>
                            <SelectCustom
                                label="Seleziona Protocollo"
                                placeholder='seleziona'
                                value={protocolType}
                                onChange={(value) => {
                                    if (value)
                                        setProtocolType(value)
                                }}
                                options={[
                                    { value: 'entrata', label: 'Protocollo Entrata' },
                                    { value: 'partenza', label: 'Protocollo Partenza' }
                                ]}
                            />
                        </div>
                    </div>
                    {
                        protocolType === 'entrata' &&
                        <div className="pb-5 mt-4">
                            <ProtocolSearch
                                type="entry"
                                onSelect={(value) => console.log(value)}
                            />
                        </div>
                    }
                    {
                        protocolType === 'partenza' &&
                        <div className="pb-5 mt-4">
                            <ProtocolSearch
                                type="departure"
                                onSelect={(value) => console.log(value)}
                            />
                        </div>
                    }
                    <div className='mt-4'>

                        <TextArea
                            label='Note'
                        />
                    </div>

                </div>
                <div className='mt-4 pb-4' style={{ padding: '0px 24px', paddingBottom: '24px' }}>
                    <p className='sectionSubTitle text-left mb-3'>Riepilogo Richieste Varie</p>
                    <TableSelectWithOperations
                        onChange={(value) => console.log()}// ON CHANGE TO FUTURE
                        headers={['Protocollo', 'Note']}
                        data={[
                            { value: '1', labels: ['22/02/2025', '22/02/2025'] },
                            { value: '2', labels: ['22/02/2025', '22/02/2025'] },
                            { value: '3', labels: ['22/02/2025', '22/02/2025'] },
                        ]}
                    />
                </div>
            </div>
        </div>
    )
}